import { DEFAULT_LANGUAGE, Language, FALLBACK_LANGUAGE } from './constants';

export const isValidLanguage = (
  lang: string,
  availableLanguages: readonly string[],
): lang is Language => {
  return availableLanguages.includes(lang);
};

export const getValidLanguage = (
  lang: string | null | undefined,
  availableLanguages: readonly string[] = [FALLBACK_LANGUAGE],
): Language => {
  if (!lang) return DEFAULT_LANGUAGE;

  if (isValidLanguage(lang, availableLanguages)) {
    return lang;
  }

  if (isValidLanguage(lang, [FALLBACK_LANGUAGE])) {
    return lang;
  }

  return DEFAULT_LANGUAGE;
};
